"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./Home.css");
require("../../Styles/Page.css");
const Home = () => {
    return react_1.default.createElement("div", { className: "Home", id: "page" },
        react_1.default.createElement("h1", { id: "home-header" }, " Welcome!"),
        react_1.default.createElement("p", { id: "home-paragraph" }, "I am John Doran, a Full Stack Dev. This website is currently under construction so don't mind the bugs"));
};
exports.default = Home;
